export default "__VITE_ASSET__e3108bb0__"